export const GET_AUDIO_PROJECT_DATA_REQUEST = "GET_AUDIO_PROJECT_DATA_REQUEST" 
export const GET_AUDIO_PROJECT_DATA_SUCCESS = "GET_AUDIO_PROJECT_DATA_SUCCESS" 
export const GET_AUDIO_PROJECT_DATA_FAILURE = "GET_AUDIO_PROJECT_DATA_FAILURE" 

export const FILTER_AUDIO_PROJECT_DATA_REQUEST = "FILTER_AUDIO_PROJECT_DATA_REQUEST" 
export const FILTER_AUDIO_PROJECT_DATA_SUCCESS = "FILTER_AUDIO_PROJECT_DATA_SUCCESS" 
export const FILTER_AUDIO_PROJECT_DATA_FAILURE = "FILTER_AUDIO_PROJECT_DATA_FAILURE"

export const SORT_AUDIO_DATA_REQUEST = "SORT_AUDIO_DATA_REQUEST"
export const SORT_AUDIO_DATA_SUCCESS = "SORT_AUDIO_DATA_SUCCESS"
export const SORT_AUDIO_DATA_FAILURE = "SORT_AUDIO_DATA_FAILURE"